/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { EmailIntakeAgentControllerReceiveMutationResponse, EmailIntakeAgentControllerReceiveHeaderParams } from "../../models/emailIntakeAgentController/EmailIntakeAgentControllerReceive";

function getEmailIntakeAgentControllerReceiveUrl() {
  const res = { method: 'POST', url: `/api/v1/email-intake-agent` as const }  
  return res
}

/**
 * {@link /api/v1/email-intake-agent}
 */
export async function emailIntakeAgentControllerReceive(headers: EmailIntakeAgentControllerReceiveHeaderParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<EmailIntakeAgentControllerReceiveMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getEmailIntakeAgentControllerReceiveUrl().url.toString(), ... requestConfig, headers : { ...headers, ...requestConfig.headers } })  
  return res.data
}